<template>
	<div class="row-actions">
		<div
			v-for="(item, idx) in menuItems"
			:key="idx"
			class="icon-wrapper"
		>
			<Icon
				:icon-name="item.icon"
				size="md"
				@click.prevent="onItemClick(item)"
			/>
		</div>
	</div>
</template>

<script>
export default {
	name:  'TagRowInlineMenu',
	props: {
		menuItems: {
			type:    Array,
			default: () => [],
		},
		entry: {
			required: true,
		},
	},
	methods: {
		onItemClick(item) {
			item.handler(this.entry);
		},
	},
};
</script>

<style lang="scss" scoped>

.row-actions {
	display: flex;

	.icon-wrapper:not(:last-child) {
		margin-right: 24px;
	}
}
</style>
